'use strict';

/**
 * Decides if the supplied variable is variant label
 */
function isVariantLabel(v) {
    return typeof v === "string" || Array.isArray(v);
}

exports.isVariantLabel = isVariantLabel;
//# sourceMappingURL=is-variant-label.cjs.map
